<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="tags" /> List helpdesk category
        </span>
        <a-input
          placeholder="Search..."
          style="width: 350px; max-width: 100%; margin-right: 5px;"
          @change="onFilter"
          v-model="filter.query"
        />
        <a-button
          slot="extra"
          type="primary"
          @click="() => (visibleAdd = true)"
        >
          <a-icon type="plus" /> Add
        </a-button>
      </div>

      <a-table
        class="top-table"
        :columns="columnsAllHelpdesk"
        :data-source="helpdesks"
        size="small"
        :loading="loadingList"
        rowKey="id"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            this.currentPage = page;
          },
          pageSize: limit,
        }"
        :scroll="{ y: 'calc(100vh - 400px)', x: 'calc(100vw - 100px)' }"
      >
        <div slot="footer">
          <a-button
            :loading="loadingList"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Load more
          </a-button>
        </div>
        <div slot="stt" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>

        <span slot="processUsers" slot-scope="text">
          <span v-for="(i, index) in text" :key="i.id">
            {{ i.fullname || i.username }}
            <span v-if="index < text.length - 1">,</span>
          </span>
        </span>
        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="updatedAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="action" style="float: right;" slot-scope="text, record">
          <a-button @click="collapseVisibleEdit(record.id)">
            <a-icon title="Chỉnh sửa" type="edit" /> Edit
          </a-button>
        </span>
      </a-table>

      <a-drawer
        v-if="visibleEdit"
        title="Edit"
        placement="right"
        :visible="visibleEdit"
        @close="() => (visibleEdit = false)"
        :width="600"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <EditHelpdesk
          :idHelpdesk="idHelpdesk"
          :close="() => (visibleEdit = false)"
          :refreshAfterUpdated="refreshAfterUpdated"
          :refreshAfterDeleted="refreshAfterDeleted"
          :refreshAfterCreated="refreshAfterCreated"
        />
      </a-drawer>

      <a-drawer
        v-if="visibleAdd"
        title="Add"
        placement="right"
        :visible="visibleAdd"
        @close="() => (visibleAdd = false)"
        :width="450"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <AddHelpdesk
          :close="() => (visibleAdd = false)"
          :refreshAfterCreated="refreshAfterCreated"
        />
      </a-drawer>
    </a-card>
  </div>
</template>
<script>
import { columnsAllHelpdesk } from "./constant/column";
import AddHelpdesk from "./components/addHelpdesk";
import EditHelpdesk from "./components/editHelpdesk";
import query from "./constant/query";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";
import codeBenefit2Title from "./services/codeBenefit2Title";
import debounce from "lodash/debounce";
const limit = 10;
const startPage = 1;
const defaultFilter = { query: "", status: "ACTIVE" };
export default {
  components: {
    AddHelpdesk,
    EditHelpdesk,
  },
  data() {
    this.onFilter = debounce(this.onFilter, 500);
    return {
      limit,
      visibleEdit: false,
      visibleAdd: false,
      columnsAllHelpdesk,
      loadingList: true,
      helpdesks: [],
      idHelpdesk: "",
      filter: defaultFilter,
      currentPage: startPage,
      totalPage: startPage,
      isPagination: true,
    };
  },
  methods: {
    codeBenefit2Title,
    onGetAllHelpdesk(flag) {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getListHelpdeskCategory,
          fetchPolicy: "no-cache",
          variables: {
            limit,
            query: this.filter.query,
            page: this.totalPage,
            status: this.filter.status,
          },
        })
        .then(({ data }) => {
          this.loadingList = false;
          if (data?.getListHelpdeskCategory?.length >= 0) {
            if (flag === "PAGINATION") {
              this.helpdesks = this.helpdesks.concat([
                ...data.getListHelpdeskCategory,
              ]);
            } else {
              this.helpdesks = [...data.getListHelpdeskCategory];
            }
            // check is pagniation
            if (data.getListHelpdeskCategory.length < limit) {
              this.isPagination = false;
            } else {
              this.isPagination = true;
            }
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Lấy danh sách danh mục không thành công!",
          });
          console.log("Lấy danh sách danh mục không thành công", err);
        });
    },
    collapseVisibleEdit(id) {
      if (id) {
        this.idHelpdesk = id;
        this.visibleEdit = true;
      } else {
        this.idHelpdesk = "";
        this.visibleEdit = false;
      }
    },
    onFilter() {
      this.totalPage = startPage;
      this.currentPage = startPage;
      this.onGetAllHelpdesk("FILTER");
    },
    refreshAfterUpdated(item) {
      this.helpdesks = updateForUpdated(this.helpdesks, item);
    },
    refreshAfterDeleted(item) {
      this.helpdesks = updateForDeleted(this.helpdesks, item);
    },
    refreshAfterCreated(item) {
      this.helpdesks = updateForCreated({
        list: this.helpdesks,
        item,
        limit,
        currentPage: this.currentPage,
      });
    },
    onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.onGetAllHelpdesk("PAGINATION");
      }
    },
    onChangeStatusFilter(status) {
      this.$set(this.filter, "status", status || undefined);
      this.onFilter();
    },
  },
  created() {
    this.onGetAllHelpdesk();
  },
};
</script>
<style lang="css" scoped></style>
